export function getExcelData(data, catalogsTypeList) {
  //   data: list of [    {
  // abbreviation: "AVI"
  // catalogTypeId: 2
  // id: 12
  // name: "AVICULTURA"
  // }]
  let rows = [];
  if (data.length === 0 || catalogsTypeList.length === 0) {
    return [];
  }
  data.forEach((elem, index) => {
    var _known = {
      Numero: index + 1,
      Nombre: elem.name,
      Abreviatura: elem.abbreviation,
      Catalogo: catalogsTypeList.filter((type) => {
        return type.id === elem.catalogTypeId;
      })[0].name,
    };
    rows.push(_known);
  });
  return rows;
}
